import Vue from 'vue'
import config from '../../config/config.js'
import axios from 'axios'
import jwtDecode from 'jwt-decode'

export const state = {
  currentUser: null,
  gapiEmail: null,
  gapiToken: null,
  signingIn: false,
  etsJwtToken: null,
  identityUrl: config.identityUrl, //defaults to config file, but will be replaced by call to backend
  isRefreshing: false,
  refreshingCall: null,
  loginType: 'google',
  singleProvider: 'google',
}

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
  },
  SET_GAPI_USER(state, payload) {
    if (!!payload) {
      state.gapiEmail = payload.email
      state.gapiToken = payload.token
    } else {
      state.gapiEmail = null
      state.gapiToken = null
    }
  },
  SET_ETS_JWT_TOKEN(state, newValue) {
    state.etsJwtToken = newValue
  },
  SET_IDENTITY_URL(state, newValue) {
    state.identityUrl = newValue
  },
  SET_SIGNING_IN(state, value) {
    state.signingIn = value
  },
  setRefreshingState: (state, isRefreshing) =>
    (state.isRefreshing = isRefreshing),
  setRefreshingCall: (state, func) => (state.refreshingCall = func),
  setLoginType(state, payload) {
    state.loginType = payload
  },
}

export const getters = {
  // Whether the user is currently logged in.
  isLoggedIn(state, getters) {
    //once you have a user object being returned and saved you also want to check that that has been populated
    //doneFIXME: make sure to check for currentUser once you are getting that from your backend.
    return (
      !!state.etsJwtToken &&
      !!getters.hasCurrentToken &&
      !!state.currentUser &&
      state.currentUser.ID > 0
    )
  },
  isSuperUser: (state, getters) => {
    if (getters.userRoles.length > 0) {
      return getters.userRoles.includes('SuperUser')
    }
    return false
  },
  userAgencies: (state, getters) => {
    if (
      state.currentUser != null &&
      state.currentUser.UserAgencies.length > 0
    ) {
      return state.currentUser.UserAgencies.map((agency) => agency.Agency)
    } else {
      return []
    }
  },
  agencies: (state, getters) => {
    if (
      state.currentUser != null &&
      state.currentUser.UserAgencies.length > 0
    ) {
      return state.currentUser.UserAgencies.map((agency) => agency.Agency)
        .map((agency) => agency.Abr)
        .join(', ')
    } else {
      return ''
    }
  },
  userViewAgencies: (state, getters) => {
    var viewRoles = [1, 5, 2, 3]
    if (
      state.currentUser != null &&
      state.currentUser.UserAgencies.length > 0
    ) {
      var viewAgencies = state.currentUser.UserAgencies.filter((x) =>
        viewRoles.includes(x.AgencyRoleID)
      ).map((agency) => agency.Agency)
      var unique = []
      viewAgencies.forEach((a) => {
        var match = unique.findIndex((i) => i.ID == a.ID)
        if (match == -1) {
          unique.push(a)
        }
      })
      return unique
    } else {
      return []
    }
  },
  userEditAgencies: (state, getters) => {
    var editRoles = [1, 5, 2]
    if (
      state.currentUser != null &&
      state.currentUser.UserAgencies.length > 0
    ) {
      var viewAgencies = state.currentUser.UserAgencies.filter((x) =>
        editRoles.includes(x.AgencyRoleID)
      ).map((agency) => agency.Agency)
      var unique = []
      viewAgencies.forEach((a) => {
        var match = unique.findIndex((i) => i.ID == a.ID)
        if (match == -1) {
          unique.push(a)
        }
      })
      return unique
    } else {
      return []
    }
  },
  userAdminAgencies: (state, getters) => {
    if (
      state.currentUser != null &&
      state.currentUser.UserAgencies.length > 0
    ) {
      return state.currentUser.UserAgencies.filter(
        (x) => x.AgencyRoleID == 1
      ).map((agency) => agency.Agency)
    } else {
      return []
    }
  },
  userRoles: (state) => {
    //donefixme: alter this based on how the roles are defined in your app
    if (state.currentUser != null && state.currentUser.Roles.length > 0) {
      return state.currentUser.Roles.map((role) => role.Description)
    } else {
      return []
    }
  },
  decodedToken: (state) => {
    if (!!state.etsJwtToken) {
      return jwtDecode(state.etsJwtToken)
    } else {
      return null
    }
  },
  tokenExpiration: (state) => {
    if (!!state.etsJwtToken) {
      return new Date(jwtDecode(state.etsJwtToken).exp * 1000)
    } else {
      return null
    }
  },
  hasCurrentToken: (state) => {
    if (!!state.etsJwtToken) {
      var token = jwtDecode(state.etsJwtToken)
      if (token.exp > Date.now() / 1000) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  },
  tokenExpiresSoon(state) {
    if (!!state.etsJwtToken) {
      var token = jwtDecode(state.etsJwtToken)
      if (
        token.exp > Date.now() / 1000 && // not yet expired
        token.exp < Date.now() / 1000 + 30 * 60 // expires within 30 minutes
      ) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  },
}

export const actions = {
  //donefixme: if you are not using the username/password login and/or application registration
  // you can comment out this init (and the getIdentiyUrl action)
  // init: async ({ dispatch }) => {
  //   dispatch('getIdentityUrl')
  // },
  // Several of the un/pw actions go directly to the identity endpoint.
  // This will get it from the backend instead of the config so that we know it matches
  getIdentityUrl: async ({ commit, dispatch }) => {
    let url = `api/Register/IdentityUrl`
    try {
      // because we are running this in the init the Vue.prototype.$axios is not available
      // therefore we need the full url (with the api/ in front)
      let { data } = await axios.get(url)
      commit('SET_IDENTITY_URL', data.identityUrl)
    } catch (e) {
      dispatch('errors/handleError', e, {
        root: true,
      })
      console.log(e)
    }
  },

  // Logs out the current user.
  async logOut({ commit }) {
    console.info('logout')
    let url = `/Logout`
    Vue.prototype.$axios.get(url)
    Vue.axios.defaults.headers.common['Authorization'] = null
    if (Vue.prototype.$google) {
      var client = await Vue.prototype.$google.getClient()
      //this will prevent the auto-sign in from happening
      client.accounts.id.disableAutoSelect()
    }
    commit('SET_CURRENT_USER', null)
    commit('SET_ETS_JWT_TOKEN', null)
    commit('SET_GAPI_USER', null)
    commit('setLoginType', null)
  },
  async handleGoogleCredentials({ commit, dispatch }, payload) {
    //this is called by the callback of the google login
    commit('SET_SIGNING_IN', true)
    try {
      var userInfo = jwtDecode(payload)
      userInfo.token = payload
      userInfo.expiration = new Date(userInfo.exp * 1000)
      commit('SET_GAPI_USER', userInfo)
      commit('setLoginType', 'google')
      await dispatch('validateToken', {
        email: userInfo.email,
        token: payload,
        password: null,
      })
    } catch (e) {
      commit('SET_SIGNING_IN', false)
      commit('SET_GAPI_USER', null)
      commit('setLoginType', null)
      dispatch('errors/handleError', e, {
        root: true,
      })
    }
  },
  async getBrowserUser({ commit, dispatch }, payload) {
    try {
      //note: the new google signin is also able to retrieve passwords stored in the browser credential manager
      // this allows us to attempt to refresh the ets jwt tokens without the user needing to actively sign in again
      if (!state.signingIn) {
        return new Promise((resolve, reject) => {
          if (
            Vue.prototype.$google &&
            (state.loginType == 'google' || payload)
          ) {
            commit('SET_SIGNING_IN', true) //does the pop up for user select
            let returned = false
            Vue.prototype.$google.prompt((notification) => {
              if (notification.isNotDisplayed()) {
                if (
                  notification.getNotDisplayedReason() ==
                  'opt_out_or_no_session'
                ) {
                  //possible un/pw retrieval
                  let x = 0
                  var intervalID = window.setInterval(() => {
                    if (state.loginType == 'unpw') {
                      returned = true
                      resolve('unpw')
                    }
                    if (++x >= 10 && !returned) {
                      returned = true
                      window.clearInterval(intervalID)
                      commit('SET_SIGNING_IN', false)
                      reject('timeout')
                    }
                  }, 30)
                  //if un/pw not used we can just reject
                  // reject('no session')
                }
              }
              if (notification.isDisplayMoment()) {
                let x = 0
                var intervalID = window.setInterval(() => {
                  // if a promise has not been resolved we are going to return a reject
                  if (returned) {
                    window.clearInterval(intervalID)
                  }
                  if (++x >= 20 && !returned) {
                    returned = true
                    window.clearInterval(intervalID)
                    commit('SET_SIGNING_IN', false)
                    reject('timeout')
                  }
                }, 500)
              }
              if (notification.isDismissedMoment()) {
                if (
                  notification.getDismissedReason() == 'credential_returned'
                ) {
                  returned = true
                  commit('SET_SIGNING_IN', false)
                  resolve('google')
                }
              }
            })
          }
        })
      }
    } catch (e) {
      dispatch('errors/handleError', e, {
        root: true,
      })
      console.error(e)
      commit('SET_SIGNING_IN', false)
      dispatch('logOut')
    }
  },

  logInUnPw: async ({ commit, dispatch }, payload) => {
    payload.token = null
    commit('setLoginType', 'unpw')
    dispatch('validateToken', payload)
  },
  async refreshToken({ commit, getters, dispatch }, payload) {
    //only refresh token if we have a current (not expired) one
    if (getters.hasCurrentToken) {
      //note: work with google accounts as well as un/pw accounts where the user has saved their credentials in the browser
      if (getters.tokenExpiresSoon) {
        if (!!state.gapiEmail && !!state.gapiToken) {
          //this will refresh the google token if it has expired
          var token = jwtDecode(state.gapiToken)
          if (token.exp > Date.now() / 1000) {
            //if not expired, we use the token we have.
            await dispatch('handleGoogleCredentials', state.gapiToken)
          } else {
            await dispatch('getBrowserUser', true)
          }
        } else {
          await dispatch('getBrowserUser', true)
        }
      }
    } else {
      //try to refresh token from backend to see if we have a session already
      await dispatch('getSessionToken')
    }
  },
  async getSessionToken({ commit, dispatch, getters }, payload) {
    if (!state.signingIn) {
      commit('SET_SIGNING_IN', true)
      let url = `/Login`
      try {
        let response = await Vue.prototype.$axios.get(url)
        if (!!response.data) {
          var token = jwtDecode(response.data)
          // console.devlog(token)
          if (token && token.exp > Date.now() / 1000) {
            //we got back a valid auth token from the backend... let's set it
            commit('SET_ETS_JWT_TOKEN', response.data)
            Vue.axios.defaults.headers.common['Authorization'] =
              'Bearer ' + response.data
            //call this to retrieve user details / roles from the api
            if (getters.decodedToken.sub) {
              await dispatch('retrieveUserDetail', getters.decodedToken.sub)
            }
          } else {
            // token is invalid or expired try to get the user from google
            dispatch('getBrowserUser', true)
          }
          commit('SET_SIGNING_IN', false)
        } else {
          // no current session - try to get the user from google
          dispatch('getBrowserUser', true)
        }
      } catch (e) {
        console.error(e)
        commit('SET_SIGNING_IN', false)
      }
    }
  },
  validateToken: async ({ commit, dispatch }, payload) => {
    commit('SET_SIGNING_IN', true)
    let url = `/Login`
    let email = payload.email
    let token = payload.token
    let password = payload.password
    if ((!!email && !!token) || (!!email && !!password)) {
      try {
        let response = await Vue.prototype.$axios.post(url, {
          email: email,
          id_token: token,
          password: password,
        })
        if (!!response.data && !!response.data.auth_token) {
          //we got back an auth token from the backend... let's set it
          commit('SET_ETS_JWT_TOKEN', response.data.auth_token)
          Vue.axios.defaults.headers.common['Authorization'] =
            'Bearer ' + response.data.auth_token
          //call this to retrieve user details / roles from the api
          if (response.data.user) {
            commit('SET_CURRENT_USER', response.data.user)
            dispatch('setGtagProperties')
          } else {
            await dispatch('retrieveUserDetail', email)
          }
          commit('SET_SIGNING_IN', false)
        } else {
          console.log('jwt token not retrieved: ', response.data)
          dispatch('logOut')
        }
      } catch (e) {
        dispatch('errors/handleError', e, {
          root: true,
        })
        console.log(e)
        commit('SET_SIGNING_IN', false)
        dispatch('logOut')
      }
    } else {
      commit('SET_SIGNING_IN', false)
      dispatch('errors/handleError', 'check authentication', {
        root: true,
      })
    }
  },
  updateName: async (context, payload) => {
    let gapi = await Vue.prototype.$getGapiClient()
    let authInstance = gapi.auth2.getAuthInstance()
    let guser = await authInstance.currentUser.get()
    let googleUser = guser.getBasicProfile()
    let firstName = googleUser.getGivenName()
    let surname = googleUser.getFamilyName()
    let updatedUser = JSON.parse(JSON.stringify(payload))
    updatedUser.FirstName = firstName
    updatedUser.LastName = surname
    await Vue.prototype.$axios.put(
      `/User/UpdateName/${payload.ID}`,
      updatedUser
    )
  },
  async retrieveUserDetail(context, email) {
    try {
      let { data } = await Vue.prototype.$axios.get(
        `/User/ByEmail?email=${email}`
      )
      if (!data.FirstName && !data.LastName) {
        context.dispatch('updateName', data)
      }
      // call mutation to set user details in store
      context.commit('SET_CURRENT_USER', data)
      //send login to google analytics
      context.dispatch('setGtagProperties', data)
    } catch (e) {
      context.dispatch('errors/handleError', e, {
        root: true,
      })
      console.log(e)
      context.dispatch('logOut')
    }
  },
  setGtagProperties: (context, payload) => {
    //send login to google analytics
    Vue.prototype.$gtag.event('login', {
      method: context.state.loginType,
      agency: context.getters.agencies,
    })
    Vue.prototype.$gtag.set('user_properties', {
      agency: context.getters.agencies,
    })
  },
}
